"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  return (
    <html>
      <body style={{ textAlign: "center" }}>
        <h1 style={{ marginTop: 100, fontSize: 20 }}>Error</h1>
        <p style={{ fontSize: 14 }}>{error.message}</p>
        <div
          style={{
            width: "150px",
            display: "flex",
            position: "fixed",
            bottom: 40,
            left: 0,
            right: 0,
            margin: "auto",
            flexDirection: "column",
            gap: 15,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => reset()}
            style={{
              border: "1px solid #ccc",
              height: 30,
              padding: "0 10px",
              borderRadius: 4,
            }}
          >
            Retry
          </button>
          <button
            onClick={() => router.replace("/")}
            style={{
              border: "1px solid #ccc",
              height: 30,
              padding: "0 10px",
              borderRadius: 4,
            }}
          >
            Go Home Page
          </button>
        </div>
      </body>
    </html>
  );
}
